/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Bewerbungsprozess_Untertuetzung34Inputs */

const en__field_enum_tuda_bewerbungsprozess_untertuetzung34 = /** @type {(inputs: _Field_Enum_Tuda_Bewerbungsprozess_Untertuetzung34Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`application process support`)
};

const de__field_enum_tuda_bewerbungsprozess_untertuetzung34 = /** @type {(inputs: _Field_Enum_Tuda_Bewerbungsprozess_Untertuetzung34Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützung im Bewerbungsprozess (Bewerbungsunterlagen/ Interview)`)
};

/**
* | output |
* | --- |
* | "application process support" |
*
* @param {_Field_Enum_Tuda_Bewerbungsprozess_Untertuetzung34Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_bewerbungsprozess_untertuetzung34 = /** @type {((inputs?: _Field_Enum_Tuda_Bewerbungsprozess_Untertuetzung34Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Bewerbungsprozess_Untertuetzung34Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_bewerbungsprozess_untertuetzung34(inputs)
	return de__field_enum_tuda_bewerbungsprozess_untertuetzung34(inputs)
});
export { _field_enum_tuda_bewerbungsprozess_untertuetzung34 as "_field_enum_TUDA_BEWERBUNGSPROZESS_UNTERTUETZUNG" }